import React from 'react';
import { Box } from '@chakra-ui/react';

interface MarkdownFallbackProps {
	responseText: string;
}

const MarkdownFallback: React.FC<MarkdownFallbackProps> = (props: MarkdownFallbackProps) => {
	const { responseText } = props;

	return (
		<Box whiteSpace="pre-wrap" wordBreak="break-word">
			{responseText}
		</Box>
	);
};

export default MarkdownFallback;
